import { Injectable, Inject } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { BaseService } from './BaseService';
import { IDashboardDocument } from '../Models/IDashboardDocument';
import { ICanAddDocuments } from '../Models/ICanAddDocuments';
import { IIEPMenuItem } from '../Models/IIepMenuItem';
import { ISpedStudentDemographics } from '../Models/ISpedStudentDemographics';
import { ISpedStudentContact } from '../Models/ISpedStudentContact';
import { IIepInstance } from '../Models/IIepInstance';
import { IAdminPlacement } from '../Models/IAdminPlacement';
import { ILookupBase } from '../Models/ILookupBase';
import { ISPEDSecurityUser } from '../Models/ISPEDSecurityUser';
import { IDueDates } from '../Models/IDueDates';


@Injectable()
export class DashboardDocumentService extends BaseService {
  _baseUrl: string = "";

  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(_http);
    this._baseUrl = baseUrl;
  }

  get(url: string): Observable<IDashboardDocument[]> {
    return this._http.get<IDashboardDocument[]>(url).map((response: IDashboardDocument[]) => response as IDashboardDocument[])
      .catch(this.errorHandler);
  }

  getCanAddDocuments(url: string): Observable<ICanAddDocuments> {
    return this._http.get<ICanAddDocuments>(url).map((response: ICanAddDocuments) => response as ICanAddDocuments)
      .catch(this.errorHandler);
  }

  getAPStudent(url: string): Observable<ISpedStudentDemographics> {
    return this._http.get<ISpedStudentDemographics>(url).map((response: ISpedStudentDemographics) => response as ISpedStudentDemographics)
      .catch(this.errorHandler);
  }

  getIepStudent(url: string): Observable<ISpedStudentDemographics> {
    return this._http.get<ISpedStudentDemographics>(url).map((response: ISpedStudentDemographics) => response as ISpedStudentDemographics)
      .catch(this.errorHandler);
  }

  getSptStudent(url: string): Observable<ISpedStudentDemographics> {
    return this._http.get<ISpedStudentDemographics>(url).map((response: ISpedStudentDemographics) => response as ISpedStudentDemographics)
      .catch(this.errorHandler);
  }

  getDueDates(localStudentId: string): Observable<IDueDates> {
    return this._http.get(this._baseUrl + 'api/DashboardDocument/GetDueDates?localStudentId=' + localStudentId)
      .map((response: IDueDates) => response as IDueDates)
      .catch(this.errorHandler);
  }

  createNewIEP(localStudentId: string, meetingTypeId: number, meetingDate: Date, delayCode: string): Observable<IIepInstance> {
    return this._http.get(this._baseUrl + 'api/DashboardDocument/CreateNewIEP?localStudentIdMeetingTypeIdMeetingDateDelayCode=' + localStudentId + '^' + meetingTypeId.toString() + '^' + meetingDate.toISOString() + '^' + delayCode)
      .map((response: IIepInstance) => response as IIepInstance)
      .catch(this.errorHandler);
  }

  createNewAddendum(localStudentId: string, meetingDate: Date): Observable<IIepInstance> {
    return this._http.get(this._baseUrl + 'api/DashboardDocument/CreateNewAddendum?localStudentIdMeetingDate=' + localStudentId + '^' + meetingDate.toISOString())
      .map((response: IIepInstance) => response as IIepInstance)
      .catch(this.errorHandler);
  }

  createNewAP(localStudentId: string, meetingDate: Date): Observable<IAdminPlacement> {
    return this._http.get(this._baseUrl + 'api/DashboardDocument/CreateNewAP?localStudentIdMeetingDate=' + localStudentId + '^' + meetingDate.toISOString())
      .map((response: IAdminPlacement) => response as IAdminPlacement)
      .catch(this.errorHandler);
  }

  getAllowedMeetingTypes(url: string): Observable<ILookupBase[]> {
    return this._http.get<ILookupBase[]>(url).map((response: ILookupBase[]) => response as ILookupBase[])
      .catch(this.handleError);
  }

  refreshAPSpedStudentDemographicsAndContactsFromAeries(adminPlacementId: number): Observable<ISpedStudentDemographics> {
    return this._http.get(this._baseUrl + 'api/DashboardDocument/RefreshAPSpedStudentDemographicsAndContactsFromAeries' + adminPlacementId)
      .map((response: ISpedStudentDemographics) => response as ISpedStudentDemographics)
      .catch(this.errorHandler);
  }

  refreshIEPSpedStudentDemographicsAndContactsFromAeries(iepInstanceId: number): Observable<ISpedStudentDemographics> {
    return this._http.get(this._baseUrl + 'api/DashboardDocument/RefreshIEPSpedStudentDemographicsAndContactsFromAeries' + iepInstanceId)
      .map((response: ISpedStudentDemographics) => response as ISpedStudentDemographics)
      .catch(this.errorHandler);
  }

  refreshSpedStudentDemographicsAndContactsForSPT(sptCaseId: number): Observable<ISpedStudentDemographics> {
    return this._http.get(this._baseUrl + "api/DashboardDocument/RefreshSpedStudentDemographicsAndContactsForSPT/" + sptCaseId)
      .map((response: ISpedStudentDemographics) => response as ISpedStudentDemographics)
      .catch(this.errorHandler);
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }

}
